export const formatPhaseLabelToString = (phase: string): string => {
  return phase
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.toLowerCase().slice(1))
    .join(' ');
};

const formatPhaseLabelToKey = (phase: string): string => {
  return phase.toUpperCase().split(' ').join('_');
};

export const PHASE_ORDER = {
  CONCEPTION: ['Land Title Change', 'Tenancy Change'],
  DESIGNING_AND_PLANNING: [
    'Municipal Hearing',
    'Rezoning',
    'Plat',
    'Site Plan',
    'Accessibility Compliance',
    'Building Plan Review',
  ],
  CONSTRUCTION: [
    'Building Permit',
    'Electrical Permit',
    'Plumbing Permit',
    'Mechanical Permit',
  ],
  OTHER: ['Business Licence'],
} as const;

const PROJECT_PHASES = {
  CONCEPTION: PHASE_ORDER.CONCEPTION,
  DESIGNING_AND_PLANNING: PHASE_ORDER.DESIGNING_AND_PLANNING,
  CONSTRUCTION: PHASE_ORDER.CONSTRUCTION,
} as const;

export const getPhaseForDocumentType = (documentType: string): string => {
  const phase = Object.entries(PROJECT_PHASES).find(([, types]) =>
    types.some((type) => type.toLowerCase() === documentType.toLowerCase()),
  );

  return phase ? phase[0] : 'OTHER';
};

export const getPhaseOrder = (phase: string, type: string): number => {
  const phaseOrder =
    PHASE_ORDER[formatPhaseLabelToKey(phase) as keyof typeof PHASE_ORDER];
  if (!phaseOrder) return 0;
  const index = (phaseOrder as unknown as string[]).indexOf(type);

  return index === -1 ? phaseOrder.length : index;
};
